import React from 'react';
import PaymentsCheckBatchDetailPage from './PaymentsCheckBatchDetailPage';

const ElfPaymentsCheckBatchDetailPage: React.FC = () => (
  <PaymentsCheckBatchDetailPage variant="elf" />
);

export default ElfPaymentsCheckBatchDetailPage;
